var _construct = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/construct");

var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require('util'),
    inspect = _require.inspect;

var isObject = require('../help/is_object');

var _require2 = require('../jwk/generate'),
    _generate = _require2.generate,
    _generateSync = _require2.generateSync;

var _require3 = require('../help/consts'),
    USES_MAPPING = _require3.USES_MAPPING;

var _require4 = require('../jwk'),
    isKey = _require4.isKey,
    importKey = _require4.asKey;

var keyscore = function keyscore(key, _ref) {
  var alg = _ref.alg,
      use = _ref.use,
      ops = _ref.ops;
  var score = 0;

  if (alg && key.alg) {
    score++;
  }

  if (use && key.use) {
    score++;
  }

  if (ops && key.key_ops) {
    score++;
  }

  return score;
};

var KeyStore =
/*#__PURE__*/
function () {
  "use strict";

  function KeyStore() {
    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    _classCallCheck(this, KeyStore);

    while (keys.some(Array.isArray)) {
      keys = keys.flat ? keys.flat() : keys.reduce(function (acc, val) {
        if (Array.isArray(val)) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(val));
        }

        acc.push(val);
        return acc;
      }, []);
    }

    if (keys.some(function (k) {
      return !isKey(k) || !k.kty;
    })) {
      throw new TypeError('all keys must be instances of a key instantiated by JWK.asKey');
    }

    this._keys = new Set(keys);
  }

  _createClass(KeyStore, [{
    key: "all",
    value: function all() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          alg = _ref2.alg,
          kid = _ref2.kid,
          thumbprint = _ref2.thumbprint,
          use = _ref2.use,
          kty = _ref2.kty,
          ops = _ref2.key_ops,
          x5t = _ref2.x5t,
          x5t256 = _ref2['x5t#S256'],
          crv = _ref2.crv;

      if (ops !== undefined && (!Array.isArray(ops) || !ops.length || ops.some(function (x) {
        return typeof x !== 'string';
      }))) {
        throw new TypeError('`key_ops` must be a non-empty array of strings');
      }

      var search = {
        alg: alg,
        use: use,
        ops: ops
      };
      return _toConsumableArray(this._keys).filter(function (key) {
        var candidate = true;

        if (candidate && kid !== undefined && key.kid !== kid) {
          candidate = false;
        }

        if (candidate && thumbprint !== undefined && key.thumbprint !== thumbprint) {
          candidate = false;
        }

        if (candidate && x5t !== undefined && key.x5t !== x5t) {
          candidate = false;
        }

        if (candidate && x5t256 !== undefined && key['x5t#S256'] !== x5t256) {
          candidate = false;
        }

        if (candidate && kty !== undefined && key.kty !== kty) {
          candidate = false;
        }

        if (candidate && crv !== undefined && key.crv !== crv) {
          candidate = false;
        }

        if (alg !== undefined && !key.algorithms().has(alg)) {
          candidate = false;
        }

        if (candidate && use !== undefined && key.use !== undefined && key.use !== use) {
          candidate = false;
        } // TODO:


        if (candidate && ops !== undefined && (key.key_ops !== undefined || key.use !== undefined)) {
          var keyOps;

          if (key.key_ops) {
            keyOps = new Set(key.key_ops);
          } else {
            keyOps = USES_MAPPING[key.use];
          }

          if (ops.some(function (x) {
            return !keyOps.has(x);
          })) {
            candidate = false;
          }
        }

        return candidate;
      }).sort(function (first, second) {
        return keyscore(second, search) - keyscore(first, search);
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.all.apply(this, arguments)[0];
    }
  }, {
    key: "add",
    value: function add(key) {
      if (!isKey(key) || !key.kty) {
        throw new TypeError('key must be an instance of a key instantiated by JWK.asKey');
      }

      this._keys.add(key);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      if (!isKey(key)) {
        throw new TypeError('key must be an instance of a key instantiated by JWK.asKey');
      }

      this._keys.delete(key);
    }
  }, {
    key: "toJWKS",
    value: function toJWKS() {
      var priv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return {
        keys: _toConsumableArray(this._keys.values()).map(function (key) {
          return key.toJWK(priv && (key.private || key.secret && key.k));
        })
      };
    }
  }, {
    key: "generate",
    value: function generate() {
      var _args = arguments;
      return _regeneratorRuntime.async(function generate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this._keys;
              _context.next = 3;
              return _regeneratorRuntime.awrap(_generate.apply(void 0, _args));

            case 3:
              _context.t1 = _context.sent;

              _context.t0.add.call(_context.t0, _context.t1);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "generateSync",
    value: function generateSync() {
      this._keys.add(_generateSync.apply(void 0, arguments));
    }
  }, {
    key: inspect.custom,

    /* c8 ignore next 8 */
    value: function value() {
      return "".concat(this.constructor.name, " ").concat(inspect(this.toJWKS(false), {
        depth: Infinity,
        colors: process.stdout.isTTY,
        compact: false,
        sorted: true
      }));
    }
  }, {
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function value() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

      return _regeneratorRuntime.wrap(function value$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 3;
              _iterator = this._keys[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context2.next = 12;
                break;
              }

              key = _step.value;
              _context2.next = 9;
              return key;

            case 9:
              _iteratorNormalCompletion = true;
              _context2.next = 5;
              break;

            case 12:
              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 18:
              _context2.prev = 18;
              _context2.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 21:
              _context2.prev = 21;

              if (!_didIteratorError) {
                _context2.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context2.finish(21);

            case 25:
              return _context2.finish(18);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, value, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
  }, {
    key: "size",
    get: function get() {
      return this._keys.size;
    }
  }]);

  return KeyStore;
}();

function asKeyStore(jwks) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$ignoreErrors = _ref3.ignoreErrors,
      ignoreErrors = _ref3$ignoreErrors === void 0 ? false : _ref3$ignoreErrors,
      _ref3$calculateMissin = _ref3.calculateMissingRSAPrimes,
      calculateMissingRSAPrimes = _ref3$calculateMissin === void 0 ? false : _ref3$calculateMissin;

  if (!isObject(jwks) || !Array.isArray(jwks.keys) || jwks.keys.some(function (k) {
    return !isObject(k) || !('kty' in k);
  })) {
    throw new TypeError('jwks must be a JSON Web Key Set formatted object');
  }

  var keys = jwks.keys.map(function (jwk) {
    try {
      return importKey(jwk, {
        calculateMissingRSAPrimes: calculateMissingRSAPrimes
      });
    } catch (err) {
      if (!ignoreErrors) {
        throw err;
      }

      return undefined;
    }
  }).filter(Boolean);
  return _construct(KeyStore, _toConsumableArray(keys));
}

module.exports = {
  KeyStore: KeyStore,
  asKeyStore: asKeyStore
};